var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"file"}},[_c('span',[_vm._v(_vm._s(_vm.name))]),_c('span',{staticClass:"size"},[_vm._v(_vm._s(_vm.bytesToSize(_vm.size)))]),_c('img',{attrs:{"src":require("@/assets/img/delete.svg"),"alt":"Delete","title":"Remove file"},on:{"click":function($event){$event.stopPropagation();return _vm.remove(_vm.name)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }